'use client'

import Link from 'next/link'

import Icon from '../../components/Icon'
import type { LoadableComponentProps } from '../../types'
import { ProductControls, type ProductControlsProps } from './ProductControls'
import ProductImageGallery, { type ProductImageGalleryProps } from './ProductImageGallery'

type ProductIntroProps = LoadableComponentProps<
  ProductControlsProps &
    ProductImageGalleryProps & {
      backButton?: {
        text: string
        url: string
      }
    }
>

export default function ProductIntro({ data, loading }: ProductIntroProps) {
  return (
    <div className='flex flex-col gap-9 pb-10 xl:flex-row xl:gap-[60px] xl:pb-[100px] xl:pt-6'>
      <div className='xl:sticky xl:top-0 xl:h-max xl:flex-grow xl:basis-745 xl:px-0'>
        {data?.backButton?.url && (
          <Link
            className='flex items-center gap-1 pb-4 pl-4 pt-1 no-underline xl:hidden'
            href={data.backButton.url}
          >
            <Icon name='MdChevronLeft' size={20} />

            <p className='tag'>{data.backButton.text}</p>
          </Link>
        )}

        {loading ? (
          <ProductImageGallery loading />
        ) : (
          <ProductImageGallery data={{ galleryItems: data.galleryItems }} />
        )}
      </div>

      <div className='px-5 xl:sticky xl:top-0 xl:h-max xl:basis-555 xl:px-0'>
        {loading ? <ProductControls loading /> : <ProductControls data={{ ...data }} />}
      </div>
    </div>
  )
}
